import { Component } from '@angular/core';

import { HeaderBaseComponent } from '@ups/xplat/features';

@Component({
  selector: 'ups-ion-header',
  templateUrl: 'header.component.html',
  standalone: false,
})
export class HeaderComponent extends HeaderBaseComponent {}
